import { Logo } from "@/components/shared/Logo";
import { ResetPasswordForm } from "@/components/auth/ResetPasswordForm";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";

export function ResetPassword() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 container flex items-center justify-center py-8">
        <div className="w-full max-w-md space-y-8">
          <Logo />
          <ResetPasswordForm />
        </div>
      </main>
      <Footer />
    </div>
  );
}
